import { Request, Response } from 'kts-scaffold-framework/server';
import { CallType } from 'kts-scaffold-framework/utils/ajax';
import { Urls } from 'kts-platform-frame/entry/constant';
import ApiBasic from 'kts-platform-frame/api/ApiBasic';
import IData from './IData';
import IOptions from './IOptions';

/**
 * 用户所在公司角色信息
 */
class UserCompanyRole extends ApiBasic<IOptions, IData> {

    public async api(option: IOptions): Promise<Response<IData>> {
        const req: Request = new Request(CallType.GET, Urls.USER_COMPANY_ROLE, option);
        let data: Response<any> = await this.callAjax(req);
        return data;
    }
}

export default new UserCompanyRole().run;



// WEBPACK FOOTER //
// ./src/api/systemManage/system/user/userCompanyRole/index.ts